import { useState } from "react";
import { Link } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Mail, ArrowLeft, CheckCircle2 } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function ForgotPassword() {
    const { t } = useTranslation();
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setSent(true);
            toast.success(t("auth.forgot.sent"));
        } catch (e) {
            toast.error(formatApiError(e.response?.data?.detail) || t("auth.forgot.sent"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="bg-white min-h-screen" data-testid="forgot-password-page">
            <Navbar />
            <main className="pt-28 pb-20">
                <section className="max-w-md mx-auto px-6">
                    <div className="text-xs font-mono tracking-[0.22em] text-[var(--medx-red)] mb-3 text-center">PASSWORD RESET</div>
                    <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tighter text-center mb-8">
                        {t("auth.forgot.title")}
                    </h1>

                    <div className="card-soft p-7">
                        {sent ? (
                            <div className="text-center space-y-4" data-testid="forgot-password-sent">
                                <div className="w-16 h-16 mx-auto rounded-full bg-orange-50 grid place-items-center">
                                    <CheckCircle2 className="w-7 h-7 text-[var(--medx-orange)]" />
                                </div>
                                <h2 className="font-display text-2xl font-semibold">{t("auth.forgot.checkInbox")}</h2>
                                <p className="text-sm text-gray-600">
                                    {t("auth.forgot.sent")}
                                </p>
                                <Link to="/login" className="btn-outline inline-flex items-center gap-2 !py-2 text-sm">
                                    <ArrowLeft className="w-4 h-4" /> {t("auth.forgot.back")}
                                </Link>
                            </div>
                        ) : (
                            <form onSubmit={submit} className="space-y-4" data-testid="forgot-password-form">
                                <p className="text-sm text-gray-600 text-center mb-2">
                                    {t("auth.forgot.subtitle")}
                                </p>
                                <div>
                                    <label className="text-xs font-mono tracking-[0.18em] text-gray-500">{t("auth.forgot.email")}</label>
                                    <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                                        className="w-full mt-1 px-4 py-3 rounded-xl border border-gray-200 focus:border-[var(--medx-orange)] outline-none text-sm"
                                        placeholder="you@email.com"
                                        data-testid="forgot-password-email" />
                                </div>
                                <button type="submit" disabled={loading} className="btn-primary w-full inline-flex items-center justify-center gap-2 disabled:opacity-60" data-testid="forgot-password-submit">
                                    <Mail className="w-4 h-4" /> {loading ? t("auth.forgot.sending") : t("auth.forgot.submit")}
                                </button>
                                <div className="text-center text-sm">
                                    <Link to="/login" className="text-gray-500 hover:text-[var(--medx-red)]">{t("auth.forgot.back")}</Link>
                                </div>
                            </form>
                        )}
                    </div>
                </section>
            </main>
        </div>
    );
}
